'use client';

import { motion, useInView } from 'framer-motion';
import { ReactNode, useRef } from 'react';

interface AnimatedSectionProps {
  children: ReactNode;
  delay?: number;
  /** Skip slide-in so layout matches final position (e.g. deep-link scroll targets). */
  disableEntryAnimation?: boolean;
}

export default function AnimatedSection({
  children,
  delay = 0,
  disableEntryAnimation = false
}: AnimatedSectionProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px 0px -100px 0px'
  });
  const shouldShow = disableEntryAnimation || isInView;

  return (
    <motion.div
      ref={ref}
      initial={disableEntryAnimation ? false : { y: 60, opacity: 0 }}
      animate={shouldShow ? { y: 0, opacity: 1 } : { y: 60, opacity: 0 }}
      transition={{
        duration: 0.6,
        delay,
        ease: [0.25, 0.1, 0.25, 1]
      }}
    >
      {children}
    </motion.div>
  );
}
